import { Group } from '@mantine/core';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import type { FC } from 'react';
import type { Control, UseFormSetValue } from 'react-hook-form';

import { DateTimePicker } from '../../../../components/reactHookFormMantine/DateTimePicker.tsx';
import { useI18n } from '../../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../../IncompleteEventForm/schema.ts';

export const DateTimeControls: FC<{
  control: Control<IncompleteEventFormComplete>;
  start: Date;
  end: Date;
  setValue: UseFormSetValue<IncompleteEventFormComplete>;
  recurrenceActive?: boolean;
}> = ({ control, start, end, setValue, recurrenceActive }) => {
  const { t } = useI18n();

  const tomorrowTime = dayjs().add(1, 'day').set('hour', 15).set('minute', 0).set('second', 0).toDate();

  useEffect(() => {
    if (dayjs(end).isBefore(dayjs(start))) {
      setValue('end', dayjs(start).add(1, 'hours').toDate());
    }
  }, [start, end, setValue]);

  const startLabel = recurrenceActive
    ? (t('where-and-when_label--first-event-start') ?? 'First event starts')
    : (t('where-and-when_label--start') ?? 'Start');

  const endLabel = recurrenceActive
    ? (t('where-and-when_label--first-event-end') ?? 'First event ends')
    : (t('where-and-when_label--end') ?? 'End');

  return (
    <Group grow gap="xs">
      <DateTimePicker
        required
        control={control}
        defaultValue={tomorrowTime}
        label={startLabel}
        minDate={tomorrowTime}
        name="start"
        valueFormat="ddd, D MMM - HH:mm"
      />
      <DateTimePicker
        required
        control={control}
        label={endLabel}
        minDate={dayjs(start).add(1, 'hours').toDate()}
        name="end"
        valueFormat="ddd, D MMM - HH:mm"
      />
    </Group>
  );
};
